import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CNHealthProblem } from '../models/cnhealthproblem';
import { CNMedication } from '../models/cnmedication';
import { BecareService } from './becare.service';
import { TreatmentService, TreatmentServiceFilter } from './treatment.service';
import { PatientService } from './patient.service';
import { ProblemService, ProblemServiceFilter } from './problem.service';
import { CNTreatment } from '../models/cntreatment';
import { CNItem } from '../models/cnitem';

@Injectable({
  providedIn: 'root'
})
export class TermIndexService {

  private masterIndex: CNItem[] = [];

  constructor(private medications: TreatmentService, private problems: ProblemService,
              private patient: PatientService, private becare: BecareService) {
    this.patient.patientSelectedEvent.subscribe(selectedpatient => {
      // clean index
      this.masterIndex = [];
    });
    const medicationsSubject = this.medications.getSubject('menuright', TreatmentServiceFilter.active_medication, false);
    medicationsSubject.treatments.subscribe(patientMedications => {
      this.masterIndex = this.masterIndex.concat(patientMedications);
    });
    const problemSubject = this.problems.getSubject('menuright', ProblemServiceFilter.active, false);
    problemSubject.problems.subscribe(patientProblems => {
      this.masterIndex = this.masterIndex.concat(patientProblems);
    });
  }

  search(query: string): Observable<string[]> {
    return new Observable(observer => {
      const search = query.toLowerCase();
      const foundElements = this.masterIndex.filter(element => element.value.toLowerCase().includes(search));
      let elementsToDisplay: string[] = [];
      foundElements.forEach(element => {
        elementsToDisplay.push(element.value.trim());
      });
      const request = {
        request: {
          text: search
        }
      };
      this.becare.call('/fr/coding/search', [], request, 'post').subscribe(result => {
        console.log('coding result', result);
        elementsToDisplay = elementsToDisplay.concat(result.result);
        observer.next(elementsToDisplay);
      }, error => {
        observer.next(elementsToDisplay);
      });
    });
  }
}
